{
  "title": "Enthrall",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level enchantment",
  "level": 2,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "1 minute",
  "description": [
    "You weave a distracting string of words, causing creatures of your choice that you can see within range and that can hear you to make a Wisdom saving throw. Any creature that can’t be charmed succeeds on this saving throw automatically, and if you or your companions are fighting a creature, it has advantage on the save. On a failed save, the target has disadvantage on Wisdom (Perception) checks made to perceive any creature other than you until the spell ends or until the target can no longer hear you. The spell ends if you are incapacitated or can no longer speak."
  ],
  "spellLists": ["bard", "warlock"]
}
